export const breakpoints = {
  mobileSmall: 480,
  mobile: 768,
  tablet: 1024,
  pc: 1400,
} as const;
